import React, { ChangeEvent, useState } from 'react';
import { observer } from 'mobx-react';
import Text, { TEXT } from '~/view/components/Text/Text';
import { formatBranchLabel, getTranslate } from '~/utils/helpers';
import { IBranch } from '~/types/branches';
import { IT360MappedBranch } from '~/mobx/modalStore/types';
import Input from '~/view/components/Controls/Input/Input';
import { modalStore } from '~/mobx/modalStore';
import { localeStore } from '~/mobx/localesStore';

interface IProps {
  takerBranch: IBranch;
  branchesMapping: IT360MappedBranch[];
}

const T360BranchesMappingTableRow: React.FC<IProps> = observer(({ takerBranch, branchesMapping }: IProps) => {
  if (!takerBranch) return null;

  const mappedTo = branchesMapping.find((item: IT360MappedBranch) => item.coreId === takerBranch.id);

  const duplicates = modalStore.t360BranchesMappingModal?.duplicates ?? new Set<string | number>();

  const validate = () => {
    const mapping = modalStore.t360BranchesMappingModal?.mappedBranches ?? [];
    const duplicates = new Set<string | number>();

    mapping.forEach((value: IT360MappedBranch, index) => {
      if (mapping.filter((item: IT360MappedBranch, filterIndex) => item.integrationId === value.integrationId && filterIndex !== index).length > 0) {
        if (value.integrationId) {
          duplicates.add(value.integrationId);
        }
      }
    });

    modalStore.changeT360BranchesMappingModalDuplicates(duplicates);
  };

  const onChangeIntegrationId = (event: React.ChangeEvent<HTMLInputElement> | null) => {
    const newIdValue = event ? String(event.target.value) : '';
    let newMapping = JSON.parse(JSON.stringify(modalStore.t360BranchesMappingModal?.mappedBranches ?? []));

    if (newIdValue === '') {
      newMapping = newMapping.filter((item: IT360MappedBranch) => item.coreId !== takerBranch.id);
    } else {
      const index = newMapping.findIndex((item: IT360MappedBranch) => item.coreId === takerBranch.id);

      if (index !== -1) {
        newMapping[index].integrationId = newIdValue;
      } else {
        newMapping.push({
          coreId: takerBranch.id,
          integrationId: newIdValue,
        } as IT360MappedBranch);
      }
    }

    modalStore.changeT360BranchesMappingModalMapping(newMapping);
    validate();
  };

  return (
    <div className="t360-branches-mapping-table-row">
      <div className="t360-branches-mapping-table-row-taker-cell">
        <Text
          type={TEXT.LIST_ROW}
          text={formatBranchLabel(getTranslate(takerBranch.name), takerBranch.address)}
          className="break-word-for-taker-branches pr-2"
        />
      </div>
      <div className="t360-branches-mapping-table-row-integration-cell">
        <Input
          placeholder={localeStore.t('type_keeta_id_txt')}
          value={mappedTo?.integrationId ?? ''}
          withResetIcon={true}
          onChange={onChangeIntegrationId}
          onReset={() => onChangeIntegrationId(null)}
          error={duplicates.has(mappedTo?.integrationId ?? '')}
        />
      </div>
    </div>
  );
});

export default T360BranchesMappingTableRow;
